<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>To do List</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12"
                    lg="4"
                    md="12"
                    sm="12"
                >
                    <label>Profile</label>
                    <v-combobox
                        v-model="toDoCategoryRequest.profileSelected"
                        :items="listProfile"
                        item-text="name"
                        item-value="id"
                        :rules=[validations.required]
                        clearable
                        single-line
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col cols="12"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <label>Description</label>
                    <v-text-field
                        v-model="toDoCategoryRequest.description" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="10"
                    lg="3"
                    md="3"
                    sm="3"
                >
                    <label>MDI Icon</label>
                    <v-text-field
                        v-model="toDoCategoryRequest.mdiIconWithoutPrefix" 
                        :rules=[validations.required]
                        single-line
                        :prefix="prefix"
                        @keyup="setMdiIcon()"
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="1"
                    lg="1"
                    md="1"
                    sm="1"
                >
                    <v-icon large>{{toDoCategoryRequest.mdiIcon}}</v-icon>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <a 
                                href="https://materialdesignicons.com/"
                                target="_blank"
                            >
                                <v-chip
                                    class="ma-2"
                                    label
                                    link
                                    outlined
                                    style="border: none; font-size: 30px !important;"
                                    v-on="on"
                                >
                                    ...
                                </v-chip>
                            </a>
                        </template>
                        <span>To Go Site - Material Designer</span>
                    </v-tooltip>
                </v-col>

                
            </v-row>

            <ActionButtons
                :request="toDoCategoryRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons
        },

        data: () => ({

            validForm: true,
            prefix: 'mdi mdi-',

            toDoCategoryRequest: {
                id: 0,
                profileSelected: null,
                description: "",
                mdiIcon: "",
                mdiIconWithoutPrefix: "",
            },

            listProfile: [],

            loading: false,
            
            validations: {
                required: required,
            }
        }),

        props: {
            id: {
                default: 0
            }
        },

        methods: {

            setMdiIcon() {
                this.toDoCategoryRequest.mdiIcon = this.prefix + this.toDoCategoryRequest.mdiIconWithoutPrefix;
            },
            
            async getRegister() {

                if (this.id !== 0) {

                    let response = await this.$store.dispatch("toDoCategoryModule/GetById", this.id);

                    if (response.success) {
                        this.toDoCategoryRequest = response.result;
                        this.toDoCategoryRequest.mdiIconWithoutPrefix = this.toDoCategoryRequest.mdiIcon.replace("mdi mdi-", "");
                    }

                }
            },

            async getLists() {
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
            },

            async cancel() {
                this.$router.push({ path: "/common/toDoCategoryList" });
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {
                    this.loading = true;
                    this.showLoading();

                    this.toDoCategoryRequest.id = this.id;
                    this.toDoCategoryRequest.idProfile = this.toDoCategoryRequest.profileSelected.id;

                    const result = await this.$store.dispatch("toDoCategoryModule/CreateUpdate", this.toDoCategoryRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        this.$router.push({ path: "/common/toDoCategoryList" });
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                }
            }
        },

        created() {
            this.showLoading();

            this.getLists();
            this.getRegister();

            this.hideLoading();
        }
    })
</script>